import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, isRef as _isRef, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex agreement" }
const _hoisted_2 = { style: {"width":"0 !important","z-index":"1 !important"} }
const _hoisted_3 = ["id", "checked", "onChange"]
const _hoisted_4 = {
  class: "flex-fill",
  style: {"padding-left":"1.8em !important","z-index":"0 !important"}
}
const _hoisted_5 = ["for"]
const _hoisted_6 = ["onClick"]

import {ConfigStore} from "~/chat/ts/store/Config";
import {StorageInstance} from "~/ts/library/storage/StorageFactory";
import EulaModalMessage from "~/chat/vue/widget/form/fields/EulaModalMessage.vue";
import {useChatFormInput, useChatFormInputProps} from "~/chat/vue/widget/form/fields/useChatFormInput";
import {computed, ref} from "vue";
import {SwitchInputInterface} from "~/cabinet/vue/interface/form/elements/Interfaces";
import {
    AGREEMENT_PERSONAL_DATA_ID,
    AGREEMENT_TYPE_CUSTOM_TEMPLATE,
    AGREEMENT_TYPE_STANDART_TEMPLATE,
    AgreementConfigInterface
} from "~/chat/ts/data/ISiteParams";
import InputWrapperWithIcon from "~/chat/vue/widget/form/fields/InputWrapperWithIcon.vue";
import ChatHtmlify from "~/chat/vue/misc/ChatHtmlify.vue";
import Random from "~/ts/library/Random";
import Dictionary from "~/ts/library/Dictionary";



const __default__ = {
    name: "ChatEulaInput"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useChatFormInputProps()
},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {

function getLocalStorageKey(agreementId: string) {
    return `agreement_${agreementId}`;
}


let props = __props;

let emits = __emit;

let {exposedObject} = useChatFormInput(props);

let instanceId = Random.uid(10);

__expose(exposedObject);

let displayedAgreementId = ref<string>(null);

let agreements = computed<AgreementConfigInterface[]>(() => {
    return ConfigStore.siteParams.value.params.siteChatOptions.agreements ?? [];
});

function getSwitchByAgreement(agreement: AgreementConfigInterface): SwitchInputInterface {
    return {
        ...props.field,
        descrAfterSwitch: agreement.textAfterCheckbox
    }
}


let model = ref<Dictionary<boolean>>({});

function onInput(agreementId: string, e: InputEvent) {
    let value = !!(e.target as HTMLInputElement).checked;
    StorageInstance.set(getLocalStorageKey(agreementId), value);
    model.value[agreementId] = !!value;
    emits('update:modelValue', model.value)
}

for (let agreement of agreements.value) {
    model.value[agreement.id] = agreement.isCheckboxEnabledByDefault || !!StorageInstance.get(getLocalStorageKey(agreement.id));
}

emits("update:modelValue", model.value);

/*
if (eulaConfig.value.enabledByDefault || StorageInstance.get(EULA_ACCEPTED)) {
    emits("update:modelValue", true);
}*/

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InputWrapperWithIcon, {
    field: getSwitchByAgreement(_unref(agreements)[0]),
    required: _unref(props).required && !!_unref(agreements).find(item => item.id == _unref(AGREEMENT_PERSONAL_DATA_ID)),
    "icon-allowed": false,
    class: _normalizeClass({
            'like-input': true,
        })
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(agreements), (agreement) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("input", {
              type: "checkbox",
              id: `${agreement.id}_${_unref(instanceId)}`,
              checked: !!_unref(model)[agreement.id],
              onChange: ($event: any) => (onInput(agreement.id, $event as any))
            }, null, 40, _hoisted_3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", {
              for: `${agreement.id}_${_unref(instanceId)}`
            }, [
              _createVNode(ChatHtmlify, {
                value: agreement.textAfterCheckbox,
                bbcode: "",
                nl2br: ""
              }, null, 8, ["value"])
            ], 8, _hoisted_5),
            ([_unref(AGREEMENT_TYPE_CUSTOM_TEMPLATE), _unref(AGREEMENT_TYPE_STANDART_TEMPLATE)].includes(agreement.typeId as any))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "link-dashed ml-1",
                  onClick: _withModifiers(($event: any) => (_isRef(displayedAgreementId) //@ts-ignore
 ? displayedAgreementId.value = agreement.id : displayedAgreementId = agreement.id), ["stop","prevent"])
                }, "Ознакомиться", 8, _hoisted_6))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 256)),
      (!!_unref(displayedAgreementId))
        ? (_openBlock(), _createBlock(EulaModalMessage, {
            key: 0,
            visible: !!_unref(displayedAgreementId),
            "agreement-id": _unref(displayedAgreementId),
            "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(displayedAgreementId) //@ts-ignore
 ? displayedAgreementId.value = null : displayedAgreementId = null))
          }, null, 8, ["visible", "agreement-id"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["field", "required"]))
}
}

})